import React from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useState } from "react";
import "./customdropdown.css";

export default function CustomDropDown({ label, Options, onSelect }) {
  // console.log("label", label);
  // console.log("option", Options);

  const [value, setValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const handleClick = (selectedVal) => {
    setSelectedValue(selectedVal);
    onSelect(selectedVal);
  };

  return (
    <>
      <label className="item-search-label">{label}</label>
      <Dropdown onSelect={handleClick}>
        <Dropdown.Toggle
          variant="success"
          id="dropdown-custom-component"
          className="dropdown-custom"
        >
          <span>{selectedValue ? selectedValue : label}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Form.Control
            autoFocus
            className="my-1"
            placeholder="Search..."
            onChange={(e) => setValue(e.target.value)}
            value={value}
          />
          <ul className="list-unstyled">
            {Options.filter(
              (option) =>
                !value || option.toLowerCase().startsWith(value.toLowerCase())
            ).map((option, index) => (
              <li key={index}>  
                <Dropdown.Item eventKey={option} >
                  {option}
                </Dropdown.Item>
              </li>
            ))}
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
